<div class="modal-header border-0 py-2">
	<h5 class="modal-title modal-text-secondary">{{title | translate}}</h5>
	<i class="bi bi-x bi-lg fs-4 float-end ms-auto pointer" (click)="modal.close()"></i>
</div>
<div class="modal-body t-2 pb-4 mb-4 modal-text-dark">
	<p class="mb-0 text-break">{{message | translate}}</p>
</div>
<div class="modal-footer border-0 d-flex align-items-end mt-2">
	<button class="btn btn-modal-secondary" (click)="modal.close()">{{'Ok! Ho capito' | translate}}</button>
</div>